interface RootState {
    authFailurePopup?: {
        isOpen: boolean;
    };
}

export const getAuthFailurePopupIsOpen = (state: RootState) =>
    state.authFailurePopup?.isOpen ?? false;
